import React from 'react';

import styles from './PlatformButton.module.scss';

export interface PlatformButtonProps {
  onClick: () => void;
}

const PlatformButton: React.FC<PlatformButtonProps> = ({ onClick, children }) => {
  return (
    <div data-testid='platform-button' className={styles.ff_platform_button} onClick={() => onClick()}>
      {children}
    </div>
  );
};

export default PlatformButton;
